module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/InfluencerExample/3_1-9cc9860e5362f20c9d4c844f04421d9c.png";